import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./BookingFunnelCheckout/@module/controller.js"), path: "./BookingFunnelCheckout/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./BookingFunnelMyCart/@module/controller.js"), path: "./BookingFunnelMyCart/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./BookingFunnelStaff/@module/controller.js"), path: "./BookingFunnelStaff/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./BookingFunnelStaffMulti/@module/controller.js"), path: "./BookingFunnelStaffMulti/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./BookingFunnelTime/@module/controller.js"), path: "./BookingFunnelTime/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./BookingFunnelTimeMulti/@module/controller.js"), path: "./BookingFunnelTimeMulti/@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [];
export const styles = [{value: () => import(/* webpackPreload: true */ "./@styles/BookingFunnel.styles.js"), path: "./@styles/BookingFunnel.styles.js"}];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
